var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.453125V2.85626C1.4096 2.85626 2.55233 3.93221 2.55233 5.2594C2.55233 6.58663 1.4096 7.66254 0 7.66254V10.0657H12.2976V8.31794H13.2257V10.0657H18.5624V7.66254C17.1528 7.66254 16.01 6.58663 16.01 5.2594C16.01 3.93221 17.1528 2.85626 18.5624 2.85626V0.453125H13.2257V2.20086H12.2976V0.453125H0ZM7.42495 2.20086L8.29506 4.23534L10.6734 4.37188L8.83889 5.76461L9.43345 7.881L7.42495 6.70674L5.41646 7.881L6.01101 5.76461L4.17654 4.37188L6.55484 4.23534L7.42495 2.20086ZM12.2976 3.07473H13.2257V4.82247H12.2976V3.07473ZM12.2976 5.69633H13.2257V7.44407H12.2976V5.69633Z",
    fill: "#F7AEBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicket);
export default __webpack_public_path__ + "static/media/icon-ticket.813234a23c2de4c84d554ca3b82a3628.svg";
export { ForwardRef as ReactComponent };